import * as React from 'react'

import { useTranslation } from 'react-i18next'

import { Alert } from '@enechain/ecloud-designsystem'

import { CreateApiKeyForm } from '~/pages/ApiKeys/components/CreateApiKeyForm'
import { useApiKey } from '~/pages/ApiKeys/hooks/useApiKey'

type Props = {
  sourceApiKeyId: string
}

export const DuplicateApiKeyForm: React.FC<Props> = ({ sourceApiKeyId }) => {
  const { t } = useTranslation()
  const source = useApiKey(sourceApiKeyId)

  return (
    <>
      <Alert status="info">
        {t('pages.api_keys.create.duplicating', { name: source.name })}
      </Alert>
      <CreateApiKeyForm
        // 引き継ぐのは付与ロールだけ。名前は同じ用途と誤認しやすく、
        // 有効期限は複製元が期限切れだと過去日付になるため新しく入力させる
        defaultValues={{
          name: '',
          roleNames: source.roleNames,
          expirationType: '',
          expiresAt: '',
        }}
      />
    </>
  )
}
